import { useState } from "react";

import { NavigationContainer } from "@react-navigation/native";
import { View } from "react-native";
import { useTailwind } from "tailwind-rn";
import { useSnackbar } from "ui";
import {
  LoginNavigator,
  LoginVerificationMode,
  LoginVerifyParams,
} from "ui/merchant";
import { COUNTRY_MAP, Country, CountryCode } from "utils";

export default function LoginPage() {
  const [country, setCountry] = useState<Country>(COUNTRY_MAP.panama);
  const cellphone = "69831570";

  const { showMessage } = useSnackbar();

  async function onVerify(params: LoginVerifyParams) {
    showMessage("onVerify");
    console.log(params);
  }

  async function createLoginCode(
    countryCode: CountryCode,
    phone: string,
    mode?: LoginVerificationMode
  ) {
    showMessage("createLoginCode");
    console.log({ countryCode, phone, mode });
  }

  const tailwind = useTailwind();
  return (
    <View
      style={[
        { width: 380 },
        tailwind("border bg-red-100 flex-1 m-4 self-center"),
      ]}
    >
      <NavigationContainer>
        <LoginNavigator
          country={country}
          setCountry={setCountry}
          cellphone={cellphone}
          onVerify={onVerify}
          createLoginCode={createLoginCode}
          onAskForHelp={console.log}
          onError={console.warn}
        />
      </NavigationContainer>
    </View>
  );
}
